import React from 'react';
import './OrderConfirmationPage.scss';
import Button from 'Components/Shared/Button/Button';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';
import { DeliveryCode } from 'Store/Order/enums';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import ConfirmationMessage from './ConfirmationMessage/ConfirmationMessage';
import ConfirmationLoginContainer from './ConfirmationLogin/ConfirmationLoginContainer';
import FetchFailureMessage from 'Components/Shared/FetchFailureMessage/FetchFailureMessage';
import DownloadTicketsButton from 'Components/DownloadTicketsButton/DownloadTicketsButton';
import OrderItemSummaryContainer from 'Components/OrderItemSummary/OrderItemSummaryContainer';
import Spinner from 'Components/Shared/Spinner/Spinner';

interface IProps {
  isMobile: boolean;
  isPaid: boolean;
  isFetching: boolean;
  isSwish: boolean;
  isAutoPolling: boolean;
  deliveryCode: DeliveryCode;
  orderID: number;
  orderBarcode: string;
  onSwishPaymentStatus: () => void;
  onFinish: () => void;
}

const OrderConfirmationPage: React.SFC<IProps> = ({
  isMobile,
  isPaid,
  isFetching,
  isSwish,
  isAutoPolling,
  deliveryCode,
  orderID,
  orderBarcode,
  onSwishPaymentStatus,
  onFinish,
}) => {

  if (isFetching) {
    if (!isAutoPolling) {
      return <Spinner height='lg' />;
    }
  }
  
  const FinishButton = () => (
    <div className='order-layout-footer'>
      <Button style='button-finish' size='large' onClick={ onFinish }>
        <FormattedText
          displayName='Klart'
          formattedName='order.button.done'
        />
      </Button>
    </div>
  );

  const SwishMobileDiv = () => (
    <div>
      <p>
      <FormattedText
          displayName='Please open Swish on the device connected to your mobile number and accept the transaction'
          formattedName='swish.div.title'
          style='bold-text'
        />
      </p>
      <a href={"swish://"}>
      <FormattedText
          displayName='You can use this link if Swish app is installed on this device'
          formattedName='swish.open.on.this.device'
          style='normal-text'
        />
      </a>      
      <br/><br/>
      <Spinner style='spinner-fixed' />
      <FormattedText
          displayName='Waiting for payment approval or click on the button to see the status of your payment'
          formattedName='swish.waiting.for.payment.approval'
          style='bold-text'
        />
      <br/><br/>
      <Button onClick={ onSwishPaymentStatus }>
        <FormattedText
          displayName='Check payment status'
          formattedName='swish.check.payment.status.manually'
        />
      </Button>
    </div>
  );

  const SwishDesktopDiv = () => (
    <div>
      <p>
      <FormattedText
          displayName='Please open Swish on the device connected to your mobile number and accept the transaction'
          formattedName='swish.div.title'
          style='bold-text'
        />
      </p>
      <Spinner style='spinner-fixed' />
      <FormattedText
          displayName='Waiting for payment approval or click on the button to see the status of your payment'
          formattedName='swish.waiting.for.payment.approval'
          style='bold-text'
        />
      <br/><br/>
      <Button onClick={ onSwishPaymentStatus }>
        <FormattedText
          displayName='Check payment status'
          formattedName='swish.check.payment.status.manually'
        />
      </Button>
    </div>
  );

  if (!isPaid) {
    if (isSwish)
    {
      if (isMobile)
      {
        return (
          <div className='order-confirmation-page'>
            <SwishMobileDiv />
          </div>
        )
      }
      else
      {
        return (
          <div className='order-confirmation-page'>
            <SwishDesktopDiv />
          </div>
        )
      }
    }
    return (
      <div className='order-confirmation-page'>
        <WrapperBox style='order-confirmation-page'>
          <FetchFailureMessage />
        </WrapperBox>
        <FinishButton />
      </div>
    );
  }

  return (
    <div className='order-confirmation-page'>
      <WrapperBox>
        <ConfirmationMessage { ... { orderID, deliveryCode } } />
        <OrderItemSummaryContainer { ... { noWrapper: true } } />
        <DownloadTicketsButton { ... { orderID, orderBarcode, deliveryCode } } />
        <ConfirmationLoginContainer />
      </WrapperBox>
      <FinishButton />
    </div>
  );
};

export default OrderConfirmationPage;


// WEBPACK FOOTER //
// ./src/pages/OrderConfirmationPage/OrderConfirmationPage.tsx